import { AutoMap } from "@automapper/classes";

export class ELIMSSampleDTO {
    @AutoMap()
    sampleCode: string = '';
    @AutoMap()
    clientSampleCode: string = '';
    @AutoMap()
    matrix: string = '';
    @AutoMap()
    receptionDate: string = ''
    @AutoMap()
    eolReference: string = '';
    @AutoMap()
    project: string = '';
    @AutoMap()
    batchCode: string = '';
    @AutoMap()
    isBlocked: boolean = false;
}